import CaseCard from './CaseCard';

export default CaseCard;
